package com.sddamico.swigmore.api

import kotlinx.serialization.Serializable

/** [field] optionally names the request field that caused the error so the frontend can mark that input. */
@Serializable
data class ErrorResponse(val error: String, val field: String? = null)
